<template>
    <kgr-generic-select
        ref="dropdown"
        display="text"
        :value="selectedPaymentMethod"
        :options="paymentMethods"
        no-null-option
        @post-input="handleInput($event)"
    />
</template>

<script>
import GenericSelect from './GenericSelect.vue';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
    },
    props: {
        value: {
            type: [String, Object],
            required: true,
        },
        sepaDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        defaultPaymentMethod: {
            type: [String, Object],
            required: false,
            default: null,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        paymentMethods() {
            return [
                { value: 'indefinite', text: 'Undefiniert' },
                { value: 'cash', text: 'Bar' },
                { value: 'bank-transfer', text: 'Überweisung' },
                { value: 'sepa-debit', text: 'SEPA-Lastschrift', disabled: this.sepaDisabled },
                { value: 'debit-card', text: 'Kartenzahlung' },
            ];
        },
        selectedPaymentMethod() {
            if (typeof this.value === 'object' && this.value !== null) {
                return this.value;
            }
            return this.paymentMethods.find((option) => option.value === this.value) || null;
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                if (typeof newVal === 'string') {
                    const match = this.paymentMethods.find((opt) => opt.value === newVal);
                    if (match) {
                        this.$emit('input', match);
                        this.$nextTick(() => {
                            this.$emit('post-input', match);
                        });
                    }
                }
            },
        },
    },
    methods: {
        handleInput(selectedOption) {
            this.$emit('input', selectedOption);
            this.$nextTick(() => {
                this.$emit('post-input', selectedOption);
            });
        },
    },
};
</script>
